<script>
	import axios from 'redaxios'
	import Modal from './modal.svelte'

	export let content

	let disableForm
	let signupUnsuccessful
	let showModal
	let name, email

	function submit(e) {
		e.preventDefault()

		if (!name || !email) {
			alert('Please fill out both fields')
			return
		}
		if (!~name.indexOf(' ')) {
			alert('Please enter a first and last name')
			return
		}
		let names = name.split(' ')

		let firstName = names.shift()
		let lastName = names.join(' ')

		disableForm = true

		// send to backend
		axios
			.post('/wp-json/boost/v1/cc-form', {
				action: 'cc_signup_form',
				email,
				firstName,
				lastName,
			})
			.then(response => {
				let data = JSON.parse(response.data)
				if (!data.contact_id) {
					signupUnsuccessful = true
				}
			})
			.catch(error => {
				// console.log('error', error)
				signupUnsuccessful = true
			})
			.then(() => {
				showModal = true
			})
	}
</script>

<div class="newsletter-block">
	{#if content}
		<p>{content}</p>
	{/if}
	<form
		action="/"
		class="cc-form"
		on:submit={submit}
		class:disabled={disableForm}>
		<div>
			<label for="name" class="sr-only">Full Name</label>
			<input
				bind:value={name}
				type="text"
				id="name"
				required
				maxlength="99"
				placeholder="Full Name" />
			<label for="email" class="sr-only">Email</label>
			<input
				bind:value={email}
				type="email"
				id="email"
				required
				maxlength="99"
				placeholder="Email" />
		</div>
		<button class="pointer-link">Sign Up</button>
	</form>
</div>

<div>
	{#if showModal}
		<Modal on:close={() => (showModal = false)} width={500}>
			<div class="modal-inner">
				{#if signupUnsuccessful}
					<h1>Signup Unsuccessful</h1>
					<p>
						While we're working on fixing this, please subscribe directly
						<a
							href="https://visitor.r20.constantcontact.com/manage/optin?v=001l3cLBhqUqd-D7guBne6dNcyUgcjzCz8T"
							target="_blank"
							rel="noopener noreferrer">
							using this form
						</a>
						.
					</p>
				{:else}
					<h1>Signup Successful</h1>
					<p>Thank you for subscribing to our newsletter!</p>
				{/if}
			</div>
		</Modal>
	{/if}
</div>
